import * as React from "react";
import { InputText } from "primereact/inputtext";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, value, ...props }, ref) => {
    // Converter value para string se for number
    const stringValue = value !== undefined && value !== null ? String(value) : value;

    return (
      <InputText
        ref={ref}
        type={type}
        className={cn(className)}
        value={stringValue}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
